'use strict';

import {DOM} from '../helpers/DOM.js';

export default class Slider {
	constructor() {
		if (DOM.el('.levcharity_slider')) {
			this.#addEvents();
			this.update();
		}
	}

	#addEvents() {
		DOM.addEvent('LevCharityUpdateSlider', (e) => {
			this.update();
		})
	}

	async update() {
		const {Swiper} = await import('swiper/bundle');

		document.querySelectorAll('.levcharity_slider')
			.forEach(swiperElement => {
				const slidesPerView = +swiperElement?.dataset?.slidesToShow || 1;
				const slidesPerGroup = +swiperElement?.dataset?.slidesPerGroup || 1;
				const loop = (swiperElement?.dataset?.infinite || 'true') === 'true';
				const centeredSlides = (swiperElement?.dataset?.center || 'false') === 'true';

				const breakpoint_sizes = (swiperElement?.dataset?.breakpoints || '').split(',');

				const breakpoints = {};

				breakpoint_sizes.forEach(bp => {
					const slidesPerView = +swiperElement?.dataset[bp + 'SlidesToShow'] || 1;
					const slidesPerGroup = +swiperElement?.dataset[bp + 'SlidesPerGroup'] || 1;
					const centeredSlides = (swiperElement?.dataset[bp + 'Center'] || 'false') === 'true';

					breakpoints[bp] = {
						slidesPerView,
						slidesPerGroup,
						centeredSlides
					};
				});

				new Swiper(swiperElement, {
					direction: 'horizontal',
					loop,
					centeredSlides,
					autoHeight: false,
					pagination: {
						el: '.levcharity_slider_dots',
						clickable: true,
					},
					navigation: {
						nextEl: '.levcharity_slider_next_button',
						prevEl: '.levcharity_slider_prev_button',
					},
					effect: 'slide',
					spaceBetween: 20,
					slidesPerView,
					slidesPerGroup,
					breakpoints,
				});
			})


	}
}
